export const HOME = '/me';
export const ABOUT = '/about';
export const PROJECTS = '/projects';